module.exports = __webpack_public_path__ + "static/media/68747470733a2f2f72656163746e61746976652e6465762f696d672f6865616465725f6c6f676f2e737667.5537cc07.svg";